import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	max-width: 1420px;
	margin: 0 auto;
	color: ${CSSVars.white};
	text-align: center;
	position: relative;

	p {
		color: ${CSSVars.primary500};
		font-weight: 600;
		font-size: ${CSSVars.fontSizeMD};
		text-transform: uppercase;

		&.desc {
			font-weight: 300;
			font-size: ${CSSVars.fontSizeMD};
			color: white;
			max-width: 1070px;
			margin: 0 auto 50px;
			text-transform: none;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeLG};
			}
		}

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSizeXL};
		}
	}

	h2 {
		font-weight: 600;
		font-size: ${CSSVars.fontSize4XL};
		margin: 30px 0;
		font-size: ${CSSVars.fontSize2XL};

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSize4XL};
		}
	}

	.apps-container {
		width: 100%;
		display: grid;
		gap: 50px;
		grid-gap: 50px;
		grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
		grid-auto-rows: minmax(auto, 150px);
		text-align: left;

		@media (max-width: $breakpoint-3) {
			grid-template-columns: 1fr;
		}

		.app {
			background-color: ${CSSVars.gray600};
			height: fit-content;
			padding: 30px;
			border-radius: 10px;
			cursor: pointer;
			position: relative;
			display: flex;
			height: 100%;
			gap: 20px;
			border: 1px solid #2a2e42;
			transition: 0.2s;

			&:hover {
				border: 1px solid ${CSSVars.gray500};
			}

			.details {
				display: flex;
				flex-direction: column;
				gap: 5px;
				color: ${CSSVars.white};

				h3 {
					font-weight: 500;
					font-size: 18px;
					line-height: 20px;
					margin: 0;

					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					line-clamp: 2;
					-webkit-box-orient: vertical;
				}

				p {
					margin: 15px 0 0;
					font-weight: 300;
					font-size: 14px;
					line-height: 20px;
					color: ${CSSVars.white};
					text-transform: none;

					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 3;
					line-clamp: 3;
					-webkit-box-orient: vertical;
				}
			}
		}
	}
`;
